import ToasterService from '@/services/toasterService'
import _ from 'lodash'
import {mapState} from 'vuex'

/**
 * Mixin for setup advanced filters from url query
 * @type {{methods: {handleAdvancedFilters(): boolean, copyFilters(): void, restoreAdvancedFilters(): void}, props: string[]}}
 */
export const advancedFiltersMixins = {
  props: ['advancedFilters'],
  data (){
    return {
      isAdvancedFiltersApplied: false,
      _advancedFilters: null,
      selectedAdvancedOptions: [],
    }
  },
  watch: {
    isCurrentSessionFetched:{
      handler(status){
        if(status){
          this.handleAdvancedFilters()
        }
      },
      immediate: true
    },
    advancedFilters: {
      handler(value) {
        this._advancedFilters = _.cloneDeep(value)
      },
      immediate: true
    },
    selectedClient (value) {
      if (value && value.changedFromNavbar) {
        this._advancedFilters = null
        this.selectedAdvancedOptions = []
      }
    },
  },
  computed: {
     ...mapState({
      isCurrentSessionFetched: 'isCurrentSessionFetched'
    })
  },
  methods: {
    /**
     * check advanced filters and set new client if necessary
     * @returns {boolean} - true - loadPageData allowed, otherwise - false
     */
    handleAdvancedFilters () {
      if (this.isAdvancedFiltersApplied) {
        return true
      }
      if (this.advancedFilters) {
        const parsedFilters = JSON.parse(this.advancedFilters)
        const clientId = parsedFilters.client_id
        if (clientId !== this.clientId) {
          if (!this.setNewClient(clientId, true)) {
            console.warn(this.$route.name + ' client with id ', clientId, 'does not connected to current user')
          } else {
            this.restoreAdvancedFilters()
          }
        } else {
          this.restoreAdvancedFilters()
        }
        return false
      }
      return true
    },
    /**
     * convert advanced filters from query string data to object and apply them
     */
    restoreAdvancedFilters () {
      if (this.advancedFilters) {
        const parsedFilters = JSON.parse(this.advancedFilters)
        const mappedFilters = parsedFilters.filters.map((item, index) => {
          const option = this.advancedOptions.find(opt => opt.type === item.selectedField)
          const isFirst = index === 0
          const id = Date.now().valueOf()
          return {
            ...option, ...item, isFirst, id
          }
        })
        this.selectedAdvancedOptions = _.cloneDeep(mappedFilters)
        this.isAdvancedFiltersApplied = true
      }
    },

    /**
     * convert applied advanced filters into url with corresponding query
     */
    copyFilters () {
      let path = `${window.location.origin}${window.location.pathname}#${this.$route.path}?advancedFilters=`
      const copiedAdvancedFilters = []
      this.selectedAdvancedOptions.forEach(item => {
        copiedAdvancedFilters.push({
          selectedField: item.selectedField,
          selectedFilter: item.selectedFilter,
          selectedOperator: item.selectedOperator
        })
      })
      const filters = { client_id: this.clientId, filters: copiedAdvancedFilters }
      path += JSON.stringify(filters)
      path = encodeURI(path)
      this.$copyText(path)
        .then(
          e => {
            ToasterService.showToast(ToasterService.INFO_TYPE, 'Filters copied to clipboard')
          },
          err => {
            ToasterService.showToast(ToasterService.ERROR_TYPE, 'Can not copy filters')
          }
        )
    }
  }

}
